













import {Vue, Component} from 'vue-property-decorator';
import UiHexagon from '@/components/UiHexagon.vue';
@Component({components: {UiHexagon}})
export default class UiMapCell extends Vue {

  public static readonly size: number = 50;

  public x: number = 0;
  public y: number = 0;
  public hasBomb: boolean = false;
  public numberOfBombsAround: number = 0;
  public isDiscovered: boolean = false;
  public isMarked: boolean = false;

  public get cssClass(): string {
    return this.isDiscovered ? 'hexagon discovered-safe' : 'hexagon hold-fragments';
  }

  private get color(): string {
    if (this.isDiscovered) {
      return  this.hasBomb ? 'red' : 'green';
    }
    return this.isMarked ? 'orange' : 'grey';
  }

  public get style(): string {
    const x = this.x * UiMapCell.size + ((this.y % 2) === 0 ? 0 : (UiMapCell.size / 2));
    const y = this.y * UiMapCell.size * 0.75;
    return `left: ${x}px; top: ${y}px;`;
  }

  public get formattedNumberOfBombsAround(): string {
    return this.isDiscovered && this.numberOfBombsAround > 0 && !this.hasBomb ? String(this.numberOfBombsAround) : '';
  }

  private mark(event: MouseEvent): void {
    this.isMarked = !this.isMarked;
    this.$emit(this.isMarked ? 'mark' : 'unmark');
    event.preventDefault();
  }
}
